import { Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, ViewChild } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, Validators, ValidatorFn  } from '@angular/forms';
import * as _ from 'lodash';

import { Remittance } from '../../../models/remittance.model';

@Component({
  selector: 'app-eventsearch-remittancesplit',
  templateUrl: './eventsearch-remittancesplit.component.html',
})

export class EventSearchRemittanceSplitComponent implements OnInit, OnChanges {
  @Input() remittanceSplitModal: boolean;
  @Output() remittanceSplitModalChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Input() selectedRemittance: Remittance;
  @Output() onModalAction: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild('splitAmount') splitAmount: ElementRef;

  public remainingBalance = 0.00;
  public splitRemittanceForm: FormGroup;
  public splitAmounts: number[] = [];
  public unappliedAmount: number;
  public currentAmount: number;

  constructor(private fb: FormBuilder) {
  }

  ngOnInit() {
    this.initForm();
  }

  ngOnChanges() {
    if (this.selectedRemittance) {
      this.remainingBalance = this.selectedRemittance.AREngine_UnappliedAmount;
      this.unappliedAmount = this.selectedRemittance.AREngine_UnappliedAmount;
    }
  }

  initForm() {
    this.splitRemittanceForm = this.fb.group({
      splitAmount: new FormControl(null, [
        Validators.required,
        (control: AbstractControl) => this.isValidEntry(this.remainingBalance)(control),
      ]),
    });
  }

  valueInRange(value: number): boolean {
    let val = Math.abs(value) > Math.abs(_.round(this.remainingBalance, 2)) ? false : true;
    return val;
  }

  isValidEntry(currentMax: number): ValidatorFn {

    return (control: AbstractControl): { [key: string]: boolean } | null => {
        if (!control.value) {
          return null;
        }

        let roundedVal = _.round(control.value, 2);
      // 0 and in range.
        if (roundedVal === 0 || !this.valueInRange(roundedVal)) {
        return { greaterThanRemainingBalance: true };
      }
        if (this.remainingBalance < 0 && control.value > 0) {
        return { negativeValueOnly: true };
      };
        if (this.remainingBalance > 0 && control.value < 0) {
        return { positiveValueOnly: true };
      }
        return null;
    }
  }

  addSplit() {
    if (this.isValidSplit(this.currentAmount)) {
      this.splitAmounts.unshift(this.currentAmount);
      this.currentAmount = undefined;
      this.updateRemainingBalance();
    }
    this.setInputFocus();
  }

  deleteSplit(index: number) {
    this.splitAmounts.splice(index, 1);
    this.updateRemainingBalance();
  }

  updateRemainingBalance() {
    let summedAmounts = _.round(_.sum(this.splitAmounts), 2);
    this.remainingBalance = _.round((this.selectedRemittance.AREngine_UnappliedAmount - summedAmounts), 2);
  }

  isValidSplit(value: number): boolean {
    if (value === 0) {
      return false;
    }

    let sign = value < 0 ? true : false;

    let splitAmountsSum = (_.sum(this.splitAmounts) + value);
    if (splitAmountsSum > this.selectedRemittance.AREngine_UnappliedAmount ||
      value > this.remainingBalance) {
      return sign;
    }
    return true;
  }

  cancelClick() {
    this.resetData();
    this.updateRemainingBalance();
    this.remittanceSplitModal = false;
    this.remittanceSplitModalChange.emit(this.remittanceSplitModal);
    this.onModalAction.emit({ type: 'cancel' })
  }

  resetData(): void {
    this.splitAmounts = [];
    this.currentAmount = undefined;
  }

  setInputFocus() {
    this.splitAmount.nativeElement.focus();
  }
  submitClick() {
    this.onModalAction.emit({type: 'submit', value: this.splitAmounts})
    this.resetData();
  }
}



// WEBPACK FOOTER //
// ./src/app/components/event-search/eventsearch-remittancesplit/eventsearch-remittancesplit.component.ts